import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { startEndTripApi } from "../../services/data/trip";
import { Formik, Form, Field, ErrorMessage } from "formik";
import PageLoader from "../../components/PageLoader";
import { assignTripApi } from "../../services/data/trip";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";

const tripSchema = Yup.object().shape({
    start_image: Yup.array().min(1, "At least one File is required"),  
    start_otp: Yup.string().required("Please Enter the start_otp"),    
  });

const StartTripModal = ({ show, handleClose, tripid }) => {
const [loading, setLoading] = useState(false)
  const initialValues = {
    start_otp:"",
    start_image:[],   
  };
  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,             
    errors,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: tripSchema,
    onSubmit: (values) => {       
        startEndTripApi(tripid, 'start', values).then((res)=>{
         if (res.data.status === 'success'){
            toast.success(res.data.message)
            handleClose()   
         }else{
            toast.error(res.data.message)
         }        
        })
        .catch((err)=>{
            toast.error(err.response.data.message)
        })            
    },
  });

  return (
    <Modal show={show} onHide={handleClose}>
        { loading ? <PageLoader loading="Loading..."/>:(
            <>
                <Modal.Header closeButton>
                    <Modal.Title>Start Trip</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                   <form onSubmit={handleSubmit}>                   
                        <div className="container">
                            <div className="row">                                                        
                                <div className="col-12">
                                    <div className="form-group">
                                            <label htmlFor="start_otp">Start otp</label>
                                            <div className="input-group">
                                                <input
                                                className="form-control"
                                                id="start_otp"
                                                type="number"
                                                name="start_otp"
                                                placeholder="Credit Duration"
                                                value={values.start_otp}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                style={{ fontSize: "14px" }}
                                                />                            
                                            </div>
                                            {errors.start_otp && (
                                                <b className="text-danger">{errors.start_otp}</b>
                                            )}
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <label htmlFor="start_image">
                                            Image
                                        </label>                                        
                                        <div className="input-group">
                                            <div className="custom-file">
                                                <input
                                                    type="file"
                                                    className="custom-file-input"
                                                    id="start_image"
                                                    name="start_image"
                                                    multiple
                                                    accept="image/*"
                                                    onBlur={handleBlur}
                                                    onChange={(event) => {
                                                    setFieldValue(
                                                        "start_image",
                                                        Array.from(event.currentTarget.files)
                                                    );
                                                    }}                                               
                                                />
                                                <label
                                                    className="custom-file-label"
                                                    htmlFor="start_image"
                                                >
                                                    {values.start_image &&
                                                    values.start_image.map(
                                                        (file) => file.name
                                                    )}
                                                </label>
                                            </div>                                            
                                        </div>
                                        {errors.start_image && (
                                                <b className="text-danger">{errors.start_image}</b>
                                            )}
                                    </div>                                
                                </div>                                
                            </div>
                        </div>
                        <Modal.Footer>
                            <button type="submit" className="btn btn-info">
                                Submit
                            </button>
                        </Modal.Footer> 
                    </form>
                </Modal.Body>
            </>
        )}
    </Modal>
  );
};

export default StartTripModal;